import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import { ChangeEvent, Fragment } from 'react';

import { FeaturesStore } from '@servicetitan/application-data/features';
import { Stack, Text, ToggleSwitch } from '@servicetitan/design-system';
import { Label, PhoneNumberInput } from '@servicetitan/form';
import { useFormatPhone } from '@servicetitan/react-hooks';
import { useDependencies } from '@servicetitan/react-ioc';

import { DefaultNumbersStore } from '../../stores/default-numbers.store';

export const ForwardingNumberInput = observer(
    (props: {
        forwardingNumber: FieldState<string | undefined>;
        isDefault: FieldState<boolean>;
    }) => {
        const [
            {
                formState: {
                    $: { callContinuityNumber },
                },
            },
            { features },
        ] = useDependencies(DefaultNumbersStore, FeaturesStore);
        const formatPhone = useFormatPhone();
        const { forwardingNumber, isDefault } = props;

        const onForwardingNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
            forwardingNumber.onChange(event.currentTarget.value);
        };
        const onIsDefaultChange = (_0: string, value: boolean) => {
            if (value && callContinuityNumber.value) {
                forwardingNumber.onChange(callContinuityNumber.value);
                forwardingNumber.validate();
            }
            isDefault.onChange(value);
        };

        const hasDefaultNumber = !!callContinuityNumber.value;

        return (
            <Stack alignItems="center" justifyContent="space-between">
                <PhoneNumberInput
                    large
                    sip={features.EnableSipNumbers}
                    placeholder="(123) 456-7890"
                    disabled={isDefault.value}
                    error={forwardingNumber.hasError}
                    value={formatPhone(forwardingNumber.value || '')}
                    onChange={onForwardingNumberChange}
                    className={`m-b-2-i ${hasDefaultNumber ? 'w-50' : 'w-100'}`}
                    label={
                        <Fragment>
                            <Text el="span" size={2} bold>
                                {`Set ${
                                    features.EnableServiceTitanPhonesUser
                                        ? 'Call Continuity Number'
                                        : 'Forwarding Number'
                                }`}
                            </Text>
                            <Label
                                label=""
                                hasError={forwardingNumber.hasError}
                                error={forwardingNumber.error}
                            />
                        </Fragment>
                    }
                />
                {hasDefaultNumber && (
                    <ToggleSwitch
                        className="m-t-1"
                        value="useDefault"
                        label="Use Default Number"
                        checked={isDefault.value}
                        onChange={onIsDefaultChange}
                    />
                )}
            </Stack>
        );
    }
);
